<template>
  <div class="top barging-container">
    <div class="barging-card" style="padding:0px 0px; margin-top:0px; background-color:#f2f7fa; border-radius: 10px;">
      <!-- search bar -->
      <div class="w-full searchBar" id="inspectorDocBar" ref="inspectorDocBarRef" v-show="true">
        <div class="flex flex-wrap justify-end">
          <div class="flex flex-row py-2 pr-1">
            <el-date-picker v-model="params.uploadTime" size="mini" start-placeholder="Upload Start Time"
              end-placeholder="Upload End Time" prefix-icon="el-icon-date" type="datetimerange"
              :style="{ width: '320px' }" format="yyyy-MM-dd HH:mm:ss" value-format="yyyy-MM-dd HH:mm:ss"
              :default-time="['00:00:00', '23:59:59']" />
          </div>

          <div class="flex flex-row py-2 pr-1">
            <el-input v-model="params.searchValue" size="mini" clearable placeholder="Search IMO/Ship Name"
              :style="{ width: '220px' }" />
          </div>

          <div class="flex flex-row pl-1 py-2">
            <el-button size="mini" type="primary" @click="getList">Search</el-button>
          </div>
        </div>
      </div>

      <!-- table -->
      <div class="box-card barging-table" v-bind:class="{ 'mobile-view': isMobileScreen }">
        <div class="w-full Comtable" id="inspectorDocTable" ref="inspectorDocTableRef">
          <el-table key="inspectorDocumentList" :data="listData" :header-cell-style="{
            height: '55px',
            background: '#fff',
            'border-bottom': '2px solid #D6D9E1',
          }" :cell-style="getCellStyle" table-layout="auto" height="100%">
            <el-table-column align="left" prop="shipName" label="Ship Name" min-width="200" />
            <el-table-column align="left" prop="imo" label="IMO" min-width="120" />
            <el-table-column align="left" label="Document" min-width="260">
              <template slot-scope="scope">
                <span class="doc-link" @click.stop="openDoc(scope.row)">
                  {{ scope.row.originalFileName || scope.row.documentName || '-' }}
                </span>
              </template>
            </el-table-column>
            <el-table-column align="left" prop="uploadTime" label="Upload Time" min-width="180"
              :formatter="formatCompleteTime" />
            <el-table-column align="left" prop="uploadBy" label="Upload By" min-width="150" />
          </el-table>
        </div>
      </div>

      <div class="barging-pagination">
        <pagination v-show="total > 0" :total="total" :page.sync="params.pageNum" :limit.sync="params.pageSize"
          :pageSizes="[10, 20, 30, 50]" @pagination="getList" />
      </div>
    </div>

    <PdfView title="Inspector Document" :pdfUrl="pdfUrl" v-model="docDialog" />
  </div>
</template>

<script>
import PdfView from "@/components/common/pdf-view.vue";
import { mapState } from "vuex";
import { getInspectorDocumentList } from "@/services";

export default {
  name: "InspectorDocuments",
  components: { PdfView },
  data() {
    return {
      listData: [],
      total: 0,
      docDialog: false,
      pdfUrl: "",

      params: {
        pageNum: 1,
        pageSize: 10,
        searchValue: null,
        uploadTime: null, // [start, end]
      },

      refreshInterval: null,
    };
  },
  computed: {
    ...mapState(["screenType"]),
    isMobileScreen() {
      return this.screenType?.isMobileScreen ?? false;
    },
  },
  mounted() {
    this.adjustHeight();
    window.addEventListener("resize", this.adjustHeight);
    this.getList();
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.adjustHeight);
  },
  methods: {
    adjustHeight() {
      const referenceElement = document.getElementById("inspectorDocBar");
      const targetElement = document.getElementById("inspectorDocTable");
      const mobileLayout = window.innerWidth < 1025;
      const fullscreenLayout = window.innerWidth > 1440;

      if (referenceElement && targetElement) {
        const referenceHeight = referenceElement.offsetHeight;
        if (referenceHeight === 44) {
          targetElement.style.height = "calc(100vh - 220px)";
          if (fullscreenLayout) {
            targetElement.style.height = "calc(100vh - 230px)";
          }
        } else if (referenceHeight >= 80 && referenceHeight <= 90) {
          if (mobileLayout) {
            targetElement.style.height = "calc(100vh - 300px)";
          } else {
            targetElement.style.height = "calc(100vh - 280px)";
          }
        } else if (referenceHeight === 132) {
          targetElement.style.height = "calc(100vh - 340px)";
        } else if (referenceHeight === 176) {
          targetElement.style.height = "calc(100vh - 380px)";
        }
      }
    },

    getCellStyle({ rowIndex }) {
      if (rowIndex % 2 === 1) {
        return { backgroundColor: "rgba(255,255,255,0.2)" };
      }
      return { backgroundColor: "rgba(228,228,228,0.2)" };
    },

    async getList() {
      const req = { ...this.params };

      if (this.params.uploadTime && this.params.uploadTime.length === 2) {
        req.uploadTimeStart = this.params.uploadTime[0];
        req.uploadTimeEnd = this.params.uploadTime[1];
        delete req.uploadTime;
      }

      const res = await getInspectorDocumentList(req);
      this.total = res.total || 0;
      this.listData = res.rows || [];
    },

    openDoc(row) {
      if (!row || !row.documentUrl) {
        this.$message.warning("No document found");
        return;
      }

      const base = process.env.VUE_APP_BASE_API || "";
      const docUrl = row.documentUrl.startsWith("http")
        ? row.documentUrl
        : base + row.documentUrl;

      this.pdfUrl = docUrl;
      this.docDialog = true;
    },

    formatCompleteTime(row, column, cellValue) {
      if (!cellValue) return "";
      return String(cellValue).replace("T", " ");
    },
  },
};
</script>

<style scoped lang="scss">
.searchBar {
  width: 100% !important;
  background-color: #f3f7fa;
  font-size: 11px;
  color: #1D1B20;
  font-family: "Roboto";
  padding: 0px 10px 0px 10px;
}

.barging-container {
  border-radius: 10px;
}

::v-deep .pagination-container {
  background: #f2f7fa;
}

.doc-link {
  color: #409eff;
  cursor: pointer;
  text-decoration: underline;
}
</style>
